export {
  default,
  SaleLabelVariant,
  TSaleLabelRenderPropsArray,
  TSaleLabelPropsArray,
} from './SaleLabelList';
